<form>
    <div class="title-outer">
        <h2 class="form-title">{{ bikesTitle }}</h2>
    </div>

    <div class="form-section-function">
        <div class="flex-col">
            <div class="flex-row">
                <app-multiple-search [searchFields]="manageBikesFields" [searchByList]="searchByList"
                    (searchByListChange)="onSearchListChange($event)">
                </app-multiple-search>
                <div class="row-to-right">
                    <button type="button" class="button-with-icon"
                        (click)="customizeDropdownVisible=!customizeDropdownVisible"><img
                            src="assets/icons/table-edit.svg" alt="customize table">{{
                        languageService.languageJSON.Global_Customize }}</button>
                    <div class="customize-dropdown" [formGroup]="selectedColumnsGroup"
                        [hidden]="!customizeDropdownVisible">
                        <mat-selection-list formControlName="selectedColumns" class="row-basis" [disableRipple]="true"
                            (selectionChange)="columnsSelectionChanged()" class="panel-customize">
                            <mat-list-option *ngFor="let columnField of manageAllBikesFields" color="primary"
                                checkboxPosition="before" [value]="columnField.Id">
                                {{ columnField.DisplayName }}
                            </mat-list-option>
                        </mat-selection-list>
                    </div>
                    <div *ngIf="downloadingCSV" class="downloading-csv">{{
                        languageService.languageJSON.Global_Downloadig }}</div>
                    <button [ngClass]="{inactive: downloadingCSV}" type="button" class="button-with-icon"
                        (click)="downloadCSV()"><img src="assets/icons/download-file.svg" alt="download csv">
                        CSV</button>
                </div>
            </div>
            <div class="flex-row">
                <app-search-badge [searchByList]="searchByList" [listFields]="manageBikesFields"
                (searchByListChange)="onSearchListChange($event)"></app-search-badge>
            </div>
        </div>
    </div>

    <div class="form-section table">
        <div class="flex-outer flex-column table">
            <div class="flex-row header">
                <div class="flex-col"
                    [ngClass]="{'clickable':manageBikesField.GroupBy, 'bold':order==manageBikesField.FieldName}"
                    *ngFor="let manageBikesField of manageBikesFields"
                    (click)="setOrder(manageBikesField.FieldName, manageBikesField.GroupBy)">
                    {{ manageBikesField.DisplayName }}
                    <span class="order-icon" *ngIf="order==manageBikesField.FieldName && !reverse">▼</span>
                    <span class="order-icon" *ngIf="order==manageBikesField.FieldName && reverse">▲</span>
                </div>
                <div class="flex-col"></div>
            </div>
            <ng-scrollbar [hidden]="loading" [orientation]="'vertical'">
                <div class="flex-row" *ngFor="let bike of bikeList | paginate: { itemsPerPage: itemsPerPage, currentPage: page, totalItems: totalItems }">
                    <div class=" flex-col" *ngFor="let manageBikesField of manageBikesFields"
                        [ngClass]="{'uppercase': manageBikesField.Uppercase}">
                        {{ getValue(bike, manageBikesField.FieldName) }}
                    </div>
                    <div class="flex-col modify-icons">
                        <div class="icon-outer">
                            <img (click)="viewBike(bike)" src="assets/icons/eye-look.svg" />
                        </div>
                    </div>
                </div>
                <div class="flex-row" *ngIf="bikeList.length==0 && !loading">
                    <div class="flex-col" *ngIf="!hasAnySearchElement()">{{ languageService.languageJSON.Global_NoItems }}</div>
                    <div class="flex-col" *ngIf="hasAnySearchElement()">{{ languageService.languageJSON.Global_NoResult }}</div>
                </div>
            </ng-scrollbar>
            <app-loading-animation *ngIf="loading"></app-loading-animation>
        </div>
    </div>
    <div class="pagination" *ngIf="!loading">
        <div class="pagination-text">{{ getPaginationText() }}</div>
        <pagination-controls (pageChange)="onPageChangeEvent($event)"></pagination-controls>
        <div class="pagination-page">
            <span class="desc">{{languageService.languageJSON.ComponentRecalled_Rows }}:</span>
            <mat-select [(value)]="itemsPerPage">
                <mat-option *ngFor="let itemPerPage of paginationValues" [value]="itemPerPage" (click)="itemsPerPageChanged()">
                    {{ itemPerPage }}</mat-option>
            </mat-select>
        </div>
    </div>
</form>